/* eslint-disable vue/no-unused-components */
<template>
  <dv-full-screen-container>
    <DataV_Header_1 :dataVal="dataVal"></DataV_Header_1>
  </dv-full-screen-container>
</template>

<style scoped></style>

<script>
import Vue from "vue";
import DataV from "@jiaminghi/data-view";
import DataV_Header_1 from "./DataVCommons/DataV_Scroll_Ranking_Board.vue";

Vue.use(DataV);

export default {
  name: "DataVShow",
  data() {
    return {
      dataVal: {
        title: "数据排名",
        scrollData: {
          data: [
            {
              name: "周口",
              value: 55,
            },
            {
              name: "南阳",
              value: 120,
            },
            {
              name: "西峡",
              value: 78,
            },
            {
              name: "驻马店",
              value: 66,
            },
            {
              name: "新乡",
              value: 80,
            },
            {
              name: "信阳",
              value: 45,
            },
            {
              name: "漯河",
              value: 29,
            },
          ],
        },
      },
    };
  },
  components: { DataV_Header_1 },
};
</script>
